import { render, staticRenderFns } from "./AdminBasic.vue?vue&type=template&id=752fcbda&scoped=true"
import script from "./AdminBasic.vue?vue&type=script&lang=js"
export * from "./AdminBasic.vue?vue&type=script&lang=js"
import style0 from "./AdminBasic.vue?vue&type=style&index=0&id=752fcbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752fcbda",
  null
  
)

export default component.exports